module.exports = __webpack_public_path__ + "static/media/mobile-template-r.65f49235.png";